import React, { Component } from 'react';
import { Card, message } from 'antd';
import { browserHistory } from 'react-router';
import {
  queryIncuOregistappMoveOutWorkflow,
  querySaveIncuOregistappMoveOut,
} from '@api/incubator/oregistappMoveOut';

import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentDidMount() {
    this.getIncuOregistappMoveOutWorkflow();
  }

  /**
   * 提交迁出
   */
  handSubmit = item => {
    this.saveIncuOregistappMoveOut(item);
  };

  getIncuOregistappMoveOutWorkflow = params => {
    const { instance } = this.state;
    queryIncuOregistappMoveOutWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  saveIncuOregistappMoveOut = item => {
    this.setState({
      isSubmitting: true,
    });
    querySaveIncuOregistappMoveOut(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { isSubmitting, instance } = this.state;
    const dataInfo = this.props.data;
    const histories = dataInfo.histories || [];
    return (
      <div>
        <FormBase
          data={dataInfo}
          handSubmit={this.handSubmit}
          isSubmitting={isSubmitting}
          {...this.props}
        />
        <Card>
          <Process instance={instance} />
          <div style={{ marginTop: '16px' }}>
            <ProcessHistory dataSource={histories} />
          </div>
        </Card>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/incubator/oregistappMoveOut/PageEdit.js